import { render, staticRenderFns } from "./ComprasProdutos.vue?vue&type=template&id=5a32c906&scoped=true"
import script from "./ComprasProdutos.vue?vue&type=script&lang=js"
export * from "./ComprasProdutos.vue?vue&type=script&lang=js"
import style0 from "./ComprasProdutos.vue?vue&type=style&index=0&id=5a32c906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a32c906",
  null
  
)

export default component.exports